const LEGACY_MAP: Record<string, number> = { DAY: 1, WEEK: 7, MONTH: 30 };

export function normalizePeriodicity(value: unknown): number {
  if (typeof value === 'number' && Number.isFinite(value)) {
    return Math.min(30, Math.max(1, Math.trunc(value)));
  }
  if (typeof value === 'string') {
    if (LEGACY_MAP[value] != null) {
      return LEGACY_MAP[value];
    }
    const n = Number(value);
    if (!Number.isNaN(n) && value.trim() !== '') {
      return Math.min(30, Math.max(1, Math.trunc(n)));
    }
  }
  if (value && typeof value === 'object' && 'value' in (value as any)) {
    return normalizePeriodicity((value as any).value);
  }
  return 1;
}
